<template>
  <!-- Testo con i link a Condizioni d'uso e informativa (#815): `signup` è la
       label della spunta di registrazione, `google` l'avviso sotto «Accedi con
       Google». Testi in consent/legalAcceptance.js. I link aprono una nuova
       scheda (siamo spesso dentro l'iframe /iLogin) e un click sul link non
       spunta la casella. -->
  <span :data-testid="testId">
    <template v-if="variant === 'google'">{{ parts.before }}<a
        :data-testid="`${testId}-terms`" :href="termsUrl" target="_blank" rel="noopener noreferrer"
        :class="linkClass" @click.stop>{{ parts.termsLink }}</a>{{ parts.middle }}<a
        :data-testid="`${testId}-privacy`" :href="privacyUrl" target="_blank" rel="noopener noreferrer"
        :class="linkClass" @click.stop>{{ parts.privacyLink }}</a>{{ parts.after }}</template>
    <template v-else>{{ parts.before }}<a
        :data-testid="`${testId}-privacy`" :href="privacyUrl" target="_blank" rel="noopener noreferrer"
        :class="linkClass" @click.stop>{{ parts.privacyLink }}</a>{{ parts.middle }}<a
        :data-testid="`${testId}-terms`" :href="termsUrl" target="_blank" rel="noopener noreferrer"
        :class="linkClass" @click.stop>{{ parts.termsLink }}</a>{{ parts.after }}</template>
  </span>
</template>

<script>
import { GOOGLE_TERMS_PARTS, SIGNUP_TERMS_PARTS } from '@/consent/legalAcceptance.js';
import { legalUrl } from '@/consent/legalDocuments.js';

export default {
  name: 'LegalTermsText',
  props: {
    variant: { type: String, default: 'signup' },
    testId: { type: String, default: 'legal-terms' },
    linkClass: { type: String, default: 'text-primary underline hover:no-underline' },
  },
  data() {
    return { termsUrl: legalUrl('termini'), privacyUrl: legalUrl('privacy') };
  },
  computed: {
    parts() {
      return this.variant === 'google' ? GOOGLE_TERMS_PARTS : SIGNUP_TERMS_PARTS;
    },
  },
};
</script>
